<template>
  <div class="lcu-page">
    <section class="section">
      <annoucement-banner />
      <page-legend />
    </section>
    <section class="section">
      <header class="lcu-section-header">Resumen</header>
      <div class="lcu-overview-container">
        <div>
          <div class="lcu-progress-text">
            <span class="lcu-progress-circle lcu-progress-blue"></span>
            <span class="lcu-progress-title">Programas Inscritos</span>
          </div>
          <div class="lcu-progress-stat lcu-progress-statBlue">
            <span class="lcu-progress-num">{{ userProgress.enrolled }}</span>
          </div>
        </div>
        <div>
          <div class="lcu-progress-text">
            <span class="lcu-progress-circle lcu-progress-orange"></span>
            <span class="lcu-progress-title">Secciones Completadas</span>
          </div>
          <div class="lcu-progress-stat lcu-progress-statOrange">
            <span class="lcu-progress-num">{{ userProgress.sections }}</span>
          </div>
        </div>
        <div>
          <div class="lcu-progress-text">
            <span class="lcu-progress-circle lcu-progress-green"></span>
            <span class="lcu-progress-title">Programas Completados</span>
          </div>
          <div class="lcu-progress-stat lcu-progress-statGreen">
            <span class="lcu-progress-num">{{ userProgress.completed }}</span>
          </div>
        </div>
      </div>
    </section>
   <section class="section">
     <header class="lcu-section-header">Material del programa en progreso</header>
      <div v-if="!progressLoading">
        <div v-if="progress.length < 1">
          <p>No tienes ningún material en progreso.</p>
          <button-cta
            :text="'REGISTRARTE EN UN PROGRAMA'"
            :classes="['lcu-arrow-btn']"
            :type="'secondary'"
            @on-click="$router.push({ path: '/programas' })" />
        </div>
        <div v-else>
          <div class="col-grid-3">
            <ProgressCard
              v-for="(card, index) in progress"
              :card="card"
              :bgSize="'contain'"
              :key="index" />
          </div>
        </div>
      </div>
      <div class="row row-center" v-if="progressLoading">
        <spin-loader :size="'100px'" />
      </div>
   </section>
   <section class="section">
     <hr class="line-break"/>
   </section>
   <section class="section">
     <div class="lcu-home-summary">
      <div class="lcu-home-video">
       <video-player
        @on-ready="() => {}"
        :options="{
          controls: true,
          // poster: '/assets/video-thumb.png',
          sources: [
            {
              src: `${WEB_ASSETS_URL}/public-assets/lcu-welcome-video.mp4`,
              type: 'video/mp4'
            }
          ]
        }" />
      </div>
      <div class="lcu-home-p">
        <header class="lcu-section-header">La Experiencia LCU</header>
        <p>
          Legacy Christian University ofrece programas en línea y de extensión
          que brindan una educación integral en Teología Bíblica, impartición y
          la revelación de la Palabra de Dios a nivel de licenciatura, maestría y doctorado.
          Desarrollamos líderes resilientes e impactantes para esta generación.
          Operando en un formato en línea flexible, autoguiado pero riguroso,
          nuestro plan de estudios está dedicado a la excelencia en la enseñanza y
          el aprendizaje, fomentando el crecimiento de líderes sólidos y transformadores.
        </p>
      </div>
     </div>
   </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PageLegend from 'ç/page-legend/PageLegend.vue';
import ButtonCta from 'ç/buttons/Cta.vue';
import VideoPlayer from 'ç/video-player/VideoPlayer.vue';
import SpinLoader from 'ç/loaders/spin/Spin.vue';
import ProgressCard from 'ç/progress-card/ProgressCard.vue';
import Announement from 'ç/announcement/Announcement.vue';
import { WEB_ASSETS_URL } from '@/globals/constants';

export default {
  name: 'home-page',
  computed: {
    ...mapGetters(['user']),
    userProgress() {
      if (!this.user.programs) {
        return {};
      }
      const programs = this.user?.programs || {};
      const enrolled = Object.keys(programs).length;
      const sections = [];
      Object.values(programs).forEach(p => {
        Object.values(p.sections || {}).forEach(s => {
          if (s.progress.completed) {
            sections.push(s.progress.completed);
          }
        });
      });
      const completed = Object.values(programs).filter(
        program => program.completed,
      ).length;
      return { enrolled, sections: sections.length, completed };
    },
  },
  components: {
    ButtonCta,
    PageLegend,
    VideoPlayer,
    ProgressCard,
    SpinLoader,
    'annoucement-banner': Announement,
  },
  data() {
    return {
      verseLoading: false,
      verseError: false,
      internval: null,
      currentTime: null,
      timeFormat: 'dddd MMM Do YYYY, h:mm:ss a',
      loginModal: false,
      progressLoading: false,
      progress: [],
      testLoading: false,
      WEB_ASSETS_URL,
    };
  },
  created() {
    this.getLastProgress();
  },
  methods: {
    async getLastProgress() {
      this.progressLoading = true;
      try {
        const { progress } = await this.$students({
          method: 'getLastProgress',
          payload: {},
        });
        this.progress = progress;
        this.$log.info('progress: ', progress);
      } catch (e) {
        this.$log.error(e.message || e);
      } finally {
        this.progressLoading = false;
      }
    },
    checkLink(path) {
      if (!this.user.id) {
        this.loginModal = true;
        window.localStorage.setItem('lcuRequestedPath', path);
      } else {
        this.$router.push({ path });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-overview-container {
  display: grid;
  grid-template-columns: 25% 25% 1fr;
  border: 1px solid $page-border;
  border-radius: 5px;
  padding: 35px 25px;
  grid-row-gap: 25px;

  @media screen and (min-width: $tablet-min) and (max-width: $tablet-max) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media only screen and (max-width: $mobile-max) {
    grid-template-columns: 1fr;
  }
}

.lcu-progress-text {
  margin-bottom: 15px;
  white-space: nowrap;

  @media only screen and (max-width: $mobile-max) {
    margin-bottom: 5px;
  }
}

.lcu-progress-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.lcu-progress-circle {
  height: 10px;
  width: 10px;
  border-radius: 50%;
  margin-right: 10px;
  display: inline-block;
}

.lcu-progress-blue {
  background-color: $progress-blue;
}

.lcu-progress-orange {
  background-color: $progress-orange;
}

.lcu-progress-green {
  background-color: $progress-green;
}

.lcu-progress-num {
  font-family: 'raleway-extra-bold';
  font-size: 42px;
}

.lcu-progress-stat {
  border-bottom: 5px solid;
  width: 70px;
  padding-bottom: 15px;

  @media only screen and (max-width: $mobile-max) {
    padding-bottom: 5px;
  }
}

.lcu-progress-statBlue {
  border-color: $progress-blue;
}

.lcu-progress-statOrange {
  border-color: $progress-orange;
}

.lcu-progress-statGreen {
  border-color: $progress-green;
}

.lcu-arrow-btn {
  &:after {
    display: inline-block;
    font-family: 'lcu';
    content: '\e80a';
    margin-left: 10px;
  }
}

.lcu-home-summary {
  display: grid;
  grid-template-columns: 45% 1fr;
  grid-gap: 40px;

  @media only screen and (max-width: $mobile-max) {
    grid-template-columns: 1fr;
    grid-gap: 10px;
  }
}

.lcu-home-video {
  @media only screen and (max-width: $mobile-max) {
    grid-area: 2 / 1 / 3 / 3;
  }
}

.lcu-home-p {
  @media only screen and (max-width: $mobile-max) {
    grid-area: 1 / 1 / 2 / 3;
  }
}
</style>
